import { get } from '..';

const getSessionMessages = (
  sessionId: string,
  page: number = 1,
  limit: number = 10,
) => get(`chatbot-api/chat-sessions/${sessionId}/messages-v2?page=${page}&limit=${limit}`);

export default getSessionMessages;
